import type { IOption } from '../KitTypes'
import type { ArrayElement, ICheckboxOption, CheckboxValue } from './Checkbox'

export const isChecked = <T extends CheckboxValue | CheckboxValue[] = CheckboxValue>(
  value?: T,
  item?: IOption<ArrayElement<T>>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  option?: ICheckboxOption<any>,
): boolean => {
  if (Array.isArray(value)) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return value.includes(item?.value as any)
  }

  if (option) {
    return value === option.valueTrue
  }

  return Boolean(value)
}
